// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2whVI","rootNoMargin":"styles_rootNoMargin__2Cw_n"};